import React from "react";
import UserDefaultAvatar from "assets/img/user.svg";
import { useHistory } from "react-router-dom";
import AdminRightOptions from "components/AdminRightOptions";
import AuthService from "services/AuthService";
import { ReactComponent as IdCard } from "assets/img/icons/identity-card.svg";
import UserSettings from "components/UserSettings";
import ClickAwayListener from "react-click-away-listener";
import { useUserContext } from "store/contexts/userContext";
import { useGlobalContext } from "store/contexts/globalContext";
import { CSSTransition } from "react-transition-group";
import { ReactComponent as Logout } from "assets/img/icons/logout.svg";
import UserProfileMicrosoftTeamDialog from "components/UserProfileMicrosoftTeamDialog";
import UserAssessment from "components/UserAssessment/UserAssessment";
import { deleteTheToken } from "services/FirebaseService";
import { useDispatch } from "react-redux";
import * as timelineActions from "reteamStore/actions";
import LazyLoadImage from "components/LazyLoadImage";
import AppOverview from "components/AppOverview";

export default ({ team }) => {
  const dispatch = useDispatch();
  const { user, setUser, setIsAuthenticated } = useUserContext();
  const [openProfile, setOpenProfile] = React.useState(null);
  const [openUserDialog, setOpenUserDialog] = React.useState(false);
  const {
    waterCoolerActivate,
    microsoftConfigureTab,
    ringCentral,
    setGlobalSearch,
  } = useGlobalContext();
  const history = useHistory();

  const handleClickProfile = (event) => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };

  const handleLogout = async () => {
    await AuthService.logout();
    try {
      await deleteTheToken();
    } catch (e) {
      console.log(e);
    }

    // navigator.serviceWorker.getRegistrations().then((r) => {
    //   return Promise.all(r.map((reg) => reg.unregister()));
    // });
    dispatch(timelineActions.clearAllTeams());

    setGlobalSearch();
    localStorage.clear();
    setUser(null);
    setIsAuthenticated(false);
  };

  const handleUserProdile = () => {
    if (microsoftConfigureTab || ringCentral) {
      setOpenUserDialog(true);
      setOpenProfile(null);
      return;
    }
    handleCloseProfile();
    history.push(`/profile/${user?.id}`);
  };

  const handleCloseProfile = () => {
    setOpenProfile(null);
  };

  var signOut = microsoftConfigureTab && (
    <div
      className="d-block d-lg-none d-xl-none"
      style={{ height: "33px", width: "30px" }}
    >
      <div className="logoutIconCollapsed">
        <Logout onClick={handleLogout} className="logoutIconMicrosoftTeams" />
      </div>
    </div>
  );
  return (
    <>
      <div className="header-right timeline-right-headar">
        <div className="notifications">
          <div style={{ display: "flex", gap: "5px" }}>
            <AdminRightOptions team={team} />
            <div
              className="userMobile"
              style={microsoftConfigureTab ? { display: "none" } : {}}
            >
              {user && <UserAssessment history={history} show={false} />}
            </div>
            {signOut}
          </div>
          <div style={{ position: "relative" }} className="navbarUserInfo">
            <div className="userDesktop">
              {user && (
                <div className="user_info" onClick={handleClickProfile}>
                  <LazyLoadImage
                    image={user?.avatar ?? UserDefaultAvatar}
                    key={user?.id}
                    alt={"user-name"}
                    imageClassName={"userProfile"}
                    imageWrapperClassName={"userProfile"}
                  />
                  <span className="user_name">{user?.full_name}</span>
                </div>
              )}
            </div>
            <div className="userMobile">
              {user && (
                <div className="mobileSettingsUser">
                  <div className="user_info" onClick={handleUserProdile}>
                    <LazyLoadImage
                      image={user?.avatar ?? UserDefaultAvatar}
                      key={user?.id}
                      alt={"user-name"}
                      imageClassName={"userProfile"}
                      imageWrapperClassName={"userProfile"}
                    />
                  </div>
                  <UserSettings />
                </div>
              )}
            </div>
            <CSSTransition
              in={Boolean(openProfile)}
              timeout={300}
              unmountOnExit
              classNames="dropdown-element"
            >
              <ClickAwayListener onClickAway={handleCloseProfile}>
                <div className="dropdownUser">
                  <div className="dropDown">
                    <ul className="userListStart">
                      <AppOverview />
                      <hr className="dropDownDivider" />
                      <li className="dropDownItem" onClick={handleUserProdile}>
                        <IdCard className="userProfileAvatar" />
                        Profile
                      </li>
                      <UserAssessment history={history} show={true} />
                      <hr className="dropDownDivider" />
                      <li className="dropDownItem settingDropDown">
                        <UserSettings />
                      </li>
                      {!waterCoolerActivate && (
                        <>
                          <hr className="dropDownDivider" />
                          <li className="dropDownItem" onClick={handleLogout}>
                            <Logout className="userProfileAvatar" />
                            Sign Out
                          </li>
                        </>
                      )}
                    </ul>
                  </div>
                </div>
              </ClickAwayListener>
            </CSSTransition>
          </div>
        </div>
      </div>
      {openUserDialog && (
        <UserProfileMicrosoftTeamDialog
          openUserDialog={openUserDialog}
          closeDialog={() => setOpenUserDialog(false)}
        />
      )}
    </>
  );
};
